import { render, staticRenderFns } from "./CalendarEventsDialog.vue?vue&type=template&id=0fbd2a2b&scoped=true"
import script from "./CalendarEventsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarEventsDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CalendarEventsDialog.vue?vue&type=style&index=0&id=0fbd2a2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbd2a2b",
  null
  
)

export default component.exports